<template>
  <!-- <div>{{$route.params.record}}</div> -->
  <el-container style="width: 100%; height: 100%;">
    <el-aside style="width: 200px; height: 100%; background: #fff;">
      <el-menu :default-active="activeTab"
               background-color="#fff"
               text-color="#333"
               active-text-color="#333"
               style="border: none;"
               router>
        <el-submenu index="1">
          <template slot="title"><span style="font-size: 16px;">考核详情</span></template>
          <el-menu-item v-for="item in menuItems"
                        :key="item.index"
                        :index="item.index"
                        :route="item.route"
                        @click.native="changeMenu(item)">
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-main style="background-color: #fff; padding: 0px;">
      <lx-step-bar step-first="汽车维修培训"
                   :step-second=secondStep>
        <span class="lx-font-color-helper">当前实训：</span>
        <span class="lx-font-color-active"
              style="font-size: 14px;">{{ exam.name }}</span>
      </lx-step-bar>

      <div class="lx-main-inner-content">
        <!-- objective manager -->
        <el-row class="lx-m-i-title">
          <el-col :span="12">考核成绩报表</el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col>
            <el-table class="lx-table"
                      size="medium"
                      border
                      row-class-name="lx-table-row"
                      header-cell-class-name="lx-table-header-cell"
                      cell-class-name="lx-table-cell"
                      :data="recordData">
              <el-table-column prop="lexueId"
                               label="乐学号"
                               align="center"></el-table-column>
              <el-table-column prop="name"
                               label="姓名"
                               align="center"></el-table-column>
              <el-table-column label="考核实训状态"
                               align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0"
                        style="color: #FF0000">
                    未完成
                  </span>
                  <span v-else>
                    已完成
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="score"
                               label="得分"
                               align="center">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Navigator from '@/components/common/Navigator'
import StepBar from '@/components/common/StepBar'
export default {
  data () {
    return {
      menuItems: [],
      activeTab: '1-1',
      exam: {},
      recordData: [],
      secondStep: '发动机拆装与检查'
    }
  },

  components: { 'lx-navigator': Navigator, 'lx-step-bar': StepBar },

  mounted () {
    this.exam = this.$route.params.record
    this.initData()
  },

  methods: {
    initData () {
      /** 导航菜单 */
      let classArr = this.exam.checkObjectCounts
      for (let i = 0, len = classArr.length; i < len; i++) {
        this.menuItems[i] = { index: '', name: '', id: '', route: { name: '' } }
        this.menuItems[i].index = '1-' + (i + 1)
        this.menuItems[i].id = classArr[i].id
        this.menuItems[i].name = classArr[i].name + `（${classArr[i].finishedStudent}/${classArr[i].totalStudent}）`
      }
      /** 考核详情 */
      this.$xhrGet(`/checks/${this.exam.id}/classes/${this.exam.checkObjectCounts[0].id}`)
        .then(rs => {
          this.recordData = rs.data
        })
      /** 步骤条 */
      this.secondStep = this.exam.name.substring(14, this.exam.name.length - 4)
    },
    changeMenu (item) {
      this.activeTab = item.index
      this.$xhrGet(`/checks/${this.exam.id}/classes/${item.id}`)
        .then(rs => {
          this.recordData = rs.data
        })
    },
    handleImportGrade (id) {
      window.open(`/checks/${id}/export`)
    }
  }
}
</script>

<style scoped>
.el-menu-item.is-active {
  background-color: #f9f9f9 !important;
  border-left: 5px solid #5e93f6 !important;
}
/deep/ .el-submenu__title {
  background-color: #5e93f6 !important;
  height: 50px !important;
  line-height: 50px !important;
  color: #fff !important;
}
.el-menu-item {
  padding-left: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/check/CheckDetails.vue